import axios from "axios";

const RETRYABLE_STATUSES = [408, 429, 500, 502, 503, 504];
const RETRYABLE_NETWORK_CODES = [
  "EAI_AGAIN",
  "ECONNRESET",
  "ECONNREFUSED",
  "ETIMEDOUT",
  "ECONNABORTED",
  "ENOTFOUND",
  "ENETUNREACH",
];

export async function withRetry<T>(
  fn: () => Promise<T>,
  maxAttempts = 3,
  baseDelayMs = 400,
): Promise<T> {
  let lastError: unknown;

  for (let attempt = 1; attempt <= maxAttempts; attempt++) {
    try {
      return await fn();
    } catch (err) {
      lastError = err;

      const isRetryable =
        axios.isAxiosError(err) &&
        (!err.response ||
          RETRYABLE_STATUSES.includes(err.response.status) ||
          (err.code && RETRYABLE_NETWORK_CODES.includes(err.code)));

      if (!isRetryable || attempt === maxAttempts) throw err;
      await new Promise((r) => setTimeout(r, baseDelayMs * attempt));
    }
  }

  throw lastError;
}
